module.exports = __webpack_public_path__ + "static/media/work_img4.98a95d6e.jpg";